import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/gestion_/escanear")({
  beforeLoad: () => {
    throw redirect({ to: "/dorsales" });
  },
});
